import { combineReducers } from 'redux';
import { appUserReducer } from './appUserReducer';
import { apiReducer } from './apiReducer';
import { apiStateReducer } from './apiStateReducer';
import { entitiesReducer } from './entities';
import { uiReducer } from './ui';
import { reportsReducer } from './reports';
import { userSettingsReducer } from './userSettingsReducer';
import ServiceTicket from './serviceTicketReducer';
import systemAnalysisReducer from './systemAnalysisReducer';
import overviewReducer from './overviewReducer';
import machineConfigReducer from './machineConfigReducer';
import jobSummaryReducer from './jobSummaryReducer';
import jobAnalysisReducer from './jobAnalysisReducer';
import apiManagementReducer from './apiManagementReducer';
import systemPageReducer from './systemPageReducer';
import isEverReportedReducer from './isEverReportedReducer';
import tvDashboardReducer from './tv-dashboardReducer';
import softwareVersionReducer from './softwareVersionPopoverReducer';
import { workingHoursReducer } from '../components/WorkingHours/workingHoursReducer';
import { holidaysReducer } from '../components/WorkingHours/holidaysReducer';
import productionHoursApiReducer from './productionHoursApiReducer';

export default combineReducers({
  appUser: appUserReducer,
  userSettings: userSettingsReducer,
  api: apiReducer,
  apiState: apiStateReducer,
  entities: entitiesReducer,
  ui: uiReducer,
  reports: reportsReducer,
  machineConfig: machineConfigReducer,
  apiManagement: apiManagementReducer,
  serviceTicket: ServiceTicket,
  isEverReported: isEverReportedReducer,
  overview: overviewReducer,
  systemAnalysis: systemAnalysisReducer,
  systemPage: systemPageReducer,
  jobAnalysis: jobAnalysisReducer,
  jobSummary: jobSummaryReducer,
  tvDashboard: tvDashboardReducer,
  softwareVersion: softwareVersionReducer,
  workingHours: workingHoursReducer,
  holidays: holidaysReducer,
  productionHoursApi: productionHoursApiReducer,
});
